import React from 'react'
import Navbar from '../navbar/Navbar'
import ReusableComponent from '../../components/resusable/ReusableComponent'
import { domesticInvestigation, privateInvestigation } from '../../data/pageData'
import Footer from '../../components/Footer/Footer'
import '../About/About.css'

const DomesticInvestigation = () => {
  return (
    <div>
      <Navbar/>
       <div className=' .about__aside-details'> 
        <div className="aboutUs__image-asideContent">
          <h1 className='about__us-title'>{domesticInvestigation.title}</h1>
          <img src={domesticInvestigation.image} alt="about__us-img" />
          <div className='content-component'>
            <div className="content-paragraphes">
            <p className='content1'>{domesticInvestigation.contentDomestic1}</p>
              <p className='content2'>{domesticInvestigation.contentDomestic2}</p>
            <p className='content3'>{domesticInvestigation.contentDomestic3}</p>
            <p className='content4'>{domesticInvestigation.contentDomestic4}</p>
              
            </div>

          <ReusableComponent />
          </div>
          
        </div>
      </div>
      <Footer/>
    </div>
  )
}

export default DomesticInvestigation